export default "__VITE_ASSET__CAoCeYSy__"